/* eslint-disable no-console */
import axios from 'axios'

//const baseURL = 'http://sion.minpaku.ac.jp:8080/';
const baseURL = 'https://ifm.ks-engine.minpaku.ac.jp';

export default axios.create({
  baseURL: baseURL,
})